/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createTaxReturn = /* GraphQL */ `
  mutation CreateTaxReturn(
    $input: CreateTaxReturnInput!
    $condition: ModelTaxReturnConditionInput
  ) {
    createTaxReturn(input: $input, condition: $condition) {
      id
      email
      taxYear
      workFlowStatus
      workFlowChangedStatus
      currentYearDocument {
        items {
          id
          fileName
          note
          type
          s3key
          s3bucket
          s3region
          verified
          taxReturnID
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      previousYearDocument {
        items {
          id
          fileName
          note
          type
          s3key
          s3bucket
          s3region
          verified
          taxReturnID
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateTaxReturn = /* GraphQL */ `
  mutation UpdateTaxReturn(
    $input: UpdateTaxReturnInput!
    $condition: ModelTaxReturnConditionInput
  ) {
    updateTaxReturn(input: $input, condition: $condition) {
      id
      email
      taxYear
      workFlowStatus
      workFlowChangedStatus
      currentYearDocument {
        items {
          id
          fileName
          note
          type
          s3key
          s3bucket
          s3region
          verified
          taxReturnID
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      previousYearDocument {
        items {
          id
          fileName
          note
          type
          s3key
          s3bucket
          s3region
          verified
          taxReturnID
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteTaxReturn = /* GraphQL */ `
  mutation DeleteTaxReturn(
    $input: DeleteTaxReturnInput!
    $condition: ModelTaxReturnConditionInput
  ) {
    deleteTaxReturn(input: $input, condition: $condition) {
      id
      email
      taxYear
      workFlowStatus
      workFlowChangedStatus
      currentYearDocument {
        items {
          id
          fileName
          note
          type
          s3key
          s3bucket
          s3region
          verified
          taxReturnID
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      previousYearDocument {
        items {
          id
          fileName
          note
          type
          s3key
          s3bucket
          s3region
          verified
          taxReturnID
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createTaxDocument = /* GraphQL */ `
  mutation CreateTaxDocument(
    $input: CreateTaxDocumentInput!
    $condition: ModelTaxDocumentConditionInput
  ) {
    createTaxDocument(input: $input, condition: $condition) {
      id
      fileName
      note
      type
      s3key
      s3bucket
      s3region
      verified
      taxReturnID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateTaxDocument = /* GraphQL */ `
  mutation UpdateTaxDocument(
    $input: UpdateTaxDocumentInput!
    $condition: ModelTaxDocumentConditionInput
  ) {
    updateTaxDocument(input: $input, condition: $condition) {
      id
      fileName
      note
      type
      s3key
      s3bucket
      s3region
      verified
      taxReturnID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteTaxDocument = /* GraphQL */ `
  mutation DeleteTaxDocument(
    $input: DeleteTaxDocumentInput!
    $condition: ModelTaxDocumentConditionInput
  ) {
    deleteTaxDocument(input: $input, condition: $condition) {
      id
      fileName
      note
      type
      s3key
      s3bucket
      s3region
      verified
      taxReturnID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createPreviousTaxDocument = /* GraphQL */ `
  mutation CreatePreviousTaxDocument(
    $input: CreatePreviousTaxDocumentInput!
    $condition: ModelPreviousTaxDocumentConditionInput
  ) {
    createPreviousTaxDocument(input: $input, condition: $condition) {
      id
      fileName
      note
      type
      s3key
      s3bucket
      s3region
      verified
      taxReturnID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updatePreviousTaxDocument = /* GraphQL */ `
  mutation UpdatePreviousTaxDocument(
    $input: UpdatePreviousTaxDocumentInput!
    $condition: ModelPreviousTaxDocumentConditionInput
  ) {
    updatePreviousTaxDocument(input: $input, condition: $condition) {
      id
      fileName
      note
      type
      s3key
      s3bucket
      s3region
      verified
      taxReturnID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deletePreviousTaxDocument = /* GraphQL */ `
  mutation DeletePreviousTaxDocument(
    $input: DeletePreviousTaxDocumentInput!
    $condition: ModelPreviousTaxDocumentConditionInput
  ) {
    deletePreviousTaxDocument(input: $input, condition: $condition) {
      id
      fileName
      note
      type
      s3key
      s3bucket
      s3region
      verified
      taxReturnID
      createdAt
      updatedAt
      owner
    }
  }
`;
